/** Mirrors the CHECK constraints in howie_onboarding_reflections (600 characters per answer). */
export const ONBOARDING_ANSWER_MAX = 600;

const ONBOARDING_DRAFT_PREFIX = 'howie-onboarding-';

export function onboardingDraftKey(userId: string) {
  return `${ONBOARDING_DRAFT_PREFIX}${userId}`;
}

export function saveOnboardingDraft(userId: string, value: string) {
  try {
    localStorage.setItem(onboardingDraftKey(userId), value);
  } catch {
    // The reflection still works when browser storage is unavailable.
  }
}

export function clearOnboardingDraft(userId: string) {
  try {
    localStorage.removeItem(onboardingDraftKey(userId));
  } catch {
    // Storage may be unavailable in privacy-restricted browser contexts.
  }
}
